// sidecartsettingsActions.js

export const SET_IPSSIDECART_SETTINGS = 'SET_IPSSIDECART_SETTINGS';   //SIDECART Settings

export const SET_IPSCHECKOUT_SETTINGS = 'SET_IPSCHECKOUT_SETTINGS';

//------------------------ GENERAL -------------------------------------
//export const SET_IPSCHECKOUT_HOOKS = 'SET_IPSCHECKOUT_HOOKS';
export const SET_GENERAL_SETTINGS = 'SET_GENERAL_SETTINGS';






//******************************************************************* */

export const setSidecartSettings = (settings) => ({
  type: SET_IPSSIDECART_SETTINGS,
  payload: settings
});

export const setCheckoutSettings = (checkoutsettings) => ({
  type: SET_IPSCHECKOUT_SETTINGS,
  payload: checkoutsettings
});

//------------------------ GENERAL -------------------------------------

export const setGeneralSettings = (generalsettings) => ({
  type: SET_GENERAL_SETTINGS,
  payload: generalsettings
});
/*
export const setCheckoutHooks = (checkouthooks) => ({
  type: SET_IPSCHECKOUT_HOOKS,
  payload: checkouthooks
});
*/

